import client, { unwrap } from './client';

export const getCostMonths = () =>
  client.get('/profit-pulse/costs/months').then(unwrap);

export const getCosts = (month) =>
  client.get(`/profit-pulse/costs/${month}`).then(unwrap);

/** body: { costCats?, foodCostOverride?, salesTaxPct? } */
export const putCosts = (month, body) =>
  client.put(`/profit-pulse/costs/${month}`, body).then(unwrap);

export const getCostDefaults = () =>
  client.get('/profit-pulse/costs/defaults').then(unwrap);

export const putCostDefaults = (body) =>
  client.put('/profit-pulse/costs/defaults', body).then(unwrap);

export const setCostDefaultsFromMonth = (month) =>
  client.post('/profit-pulse/costs/set-defaults', { month }).then(unwrap);

export const copyCosts = (from, to) =>
  client.post('/profit-pulse/costs/copy', { from, to }).then(unwrap);
